import { BASE_URL } from "./variables";

/**
 * Create a new worker (DSW) or vendor from the spending plan's provider picker.
 * Payload: { FirstName, LastName, ProviderType: 'DSW' } or { Name, ProviderType: 'Vendor' }
 * Expected response: { success, WorkerId, Name, ProviderType }
 */
export const addProvider = async (payload) => {
  const token = localStorage.getItem('businessAuthToken') || localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(`${BASE_URL}/add-provider`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.message || data?.error || `HTTP error! status: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return data;
};

export default addProvider;
